import { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CaptchaProps {
  onVerify: (isValid: boolean) => void;
}

export function Captcha({ onVerify }: CaptchaProps) {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [operator, setOperator] = useState<'+' | '-' | 'x'>('x');
  const [answer, setAnswer] = useState('');
  const [isValid, setIsValid] = useState(false);

  const generateCaptcha = () => {
    const operators: ('+' | '-' | 'x')[] = ['+', '-', 'x'];
    const newOperator = operators[Math.floor(Math.random() * operators.length)];
    let n1 = Math.floor(Math.random() * 10) + 1;
    let n2 = Math.floor(Math.random() * 10) + 1;

    // For subtraction, ensure first number is larger
    if (newOperator === '-') {
      if (n2 > n1) [n1, n2] = [n2, n1];
    }

    setNum1(n1);
    setNum2(n2);
    setOperator(newOperator);
    setAnswer('');
    setIsValid(false);
    onVerify(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const checkAnswer = (value: string) => {
    setAnswer(value);
    let correctAnswer: number;

    switch (operator) {
      case '+':
        correctAnswer = num1 + num2;
        break;
      case '-':
        correctAnswer = num1 - num2;
        break;
      case 'x':
        correctAnswer = num1 * num2;
        break;
      default:
        correctAnswer = 0;
    }

    const isCorrect = parseInt(value) === correctAnswer;
    setIsValid(isCorrect);
    onVerify(isCorrect);
  };

  return (
    <Card className="p-4">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-lg font-medium">
          <span>{num1}</span>
          <span>{operator}</span>
          <span>{num2}</span>
          <span>=</span>
        </div>
        <Input
          type="number"
          value={answer}
          onChange={(e) => checkAnswer(e.target.value)}
          className="w-24"
          placeholder="?"
        />
        <Button
          variant="ghost"
          size="icon"
          onClick={generateCaptcha}
          className="h-8 w-8"
          type="button"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
    </Card>
  );
}